import { UpdateFieldFailureActionType } from "../fields/types";
import { Handler } from "../types/store-types";
import {
    IFormsState,
    FormsActionTypes,
    GetFormRequestActionType,
    GetFormSuccessActionType,
    GetFormFailureActionType,
    GetFormsRequestActionType,
    GetFormsSuccessActionType,
    GetFormsFailureActionType,
    CreateFormRequestActionType,
    CreateFormSuccessActionType,
    CreateFormFailureActionType,
    SetCurrentFormActionType,
    UpdateFormNameRequestActionType,
    UpdateFormNameSuccessActionType,
    UpdateFormBackgroundRequestActionType,
    UpdateFormBackgroundSuccessActionType,
    UpdateFormBackgroundFailureActionType,
    UpdateFormPageStylesRequestActionType,
    UpdateFormPageStylesSuccessActionType,
    UpdateFormPageStylesFailureActionType,
    SetFormStylesActionType,
    GetUserFontsRequestActionType,
    GetUserFontsSuccessActionType,
    GetUserFontsFailureActionType,
    SaveChangedFontsRequestActionType,
    SaveChangedFontsSuccessActionType,
    SaveChangedFontsFailureActionType,
    SetInitialFontsActionType,
    InitFormButtonsStylesActionType,
    TransferFormActionType,
    SetTransferFormDataActionType,
    TransferFormSubmissionsActionType,
    SetTransferFormLoadingActionType,
} from "./types";

/* -- Init Form Buttons Styles Handler -- */

const initFormButtons: Handler<IFormsState, InitFormButtonsStylesActionType> = (state, { payload }) => {
    setTimeout(() => {
        window.declareFields(payload);
    });
    return { ...state };
};

/* -- Get Forms Request Handlers -- */

const getFormsRequest: Handler<IFormsState, GetFormsRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const getFormsSuccess: Handler<IFormsState, GetFormsSuccessActionType> = (state, { payload: { ownerId } }) => {
    return { ...state, ownerId, isLoading: false, error: null };
};

const getFormsFailure: Handler<IFormsState, GetFormsFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, error: payload };
};

/* -- Get Form Request Handlers -- */

const getFormRequest: Handler<IFormsState, GetFormRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const getFormSuccess: Handler<IFormsState, GetFormSuccessActionType> = (state, { payload }) => {
    return { ...state, ownerId: payload.ownerId, error: null };
};

const getFormFailure: Handler<IFormsState, GetFormFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, error: payload };
};

/* -- Create Form Request Handlers -- */

const createFormRequest: Handler<IFormsState, CreateFormRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const createFormSuccess: Handler<IFormsState, CreateFormSuccessActionType> = state => {
    return { ...state, error: null };
};

const createFormFailure: Handler<IFormsState, CreateFormFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, error: payload };
};

/* -- Update Form Name Request Handlers -- */

const updateFormNameRequest: Handler<IFormsState, UpdateFormNameRequestActionType> = state => {
    return { ...state, error: null };
};

const updateFormNameSuccess: Handler<IFormsState, UpdateFormNameSuccessActionType> = state => {
    return { ...state, error: null };
};

const updateFormNameFailure: Handler<IFormsState, UpdateFieldFailureActionType> = (state, { payload }) => {
    return { ...state, error: payload };
};

/* -- Update Form Background Request Handlers -- */

const updateFormBackgroundRequest: Handler<IFormsState, UpdateFormBackgroundRequestActionType> = (
    state,
    { payload },
) => {
    const { styles } = state;
    return { ...state, styles: { ...styles, background: payload.background }, error: null };
};

const updateFormBackgroundSuccess: Handler<IFormsState, UpdateFormBackgroundSuccessActionType> = state => {
    return { ...state, error: null };
};

const updateFormBackgroundFailure: Handler<IFormsState, UpdateFormBackgroundFailureActionType> = (
    state,
    { payload },
) => {
    return { ...state, error: payload };
};

/* -- Update Form Page Styles Request Handlers -- */

const updateFormPageStylesRequest: Handler<IFormsState, UpdateFormPageStylesRequestActionType> = (
    state,
    { payload },
) => {
    const { styles } = state;
    console.log("NEW STATE", { ...state, styles: { ...styles, page: payload.page }, error: null });

    return { ...state, styles: { ...styles, page: payload.page }, error: null };
};

const updateFormPageStylesSuccess: Handler<IFormsState, UpdateFormPageStylesSuccessActionType> = state => {
    return { ...state, error: null };
};

const updateFormPageStylesFailure: Handler<IFormsState, UpdateFormPageStylesFailureActionType> = (
    state,
    { payload },
) => {
    return { ...state, error: payload };
};

const setCurrentForm: Handler<IFormsState, SetCurrentFormActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, current: payload };
};

const setFormStyles: Handler<IFormsState, SetFormStylesActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, styles: payload ? payload : state.styles };
};

/* -- Get User fonts Request Handlers -- */

const setInitialFonts: Handler<IFormsState, SetInitialFontsActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, error: null, fonts: payload.fonts };
};

const getUserFontsRequest: Handler<IFormsState, GetUserFontsRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const getUserFontsSuccess: Handler<IFormsState, GetUserFontsSuccessActionType> = (state, { payload: { fonts } }) => {
    return { ...state, isLoading: false, error: null, fonts };
};

const getUserFontsFailure: Handler<IFormsState, GetUserFontsFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, error: payload };
};

/* -- Save Changed User fonts Request Handlers -- */

const saveChangedFontsRequest: Handler<IFormsState, SaveChangedFontsRequestActionType> = (
    state,
    { payload: { font } },
) => {
    return { ...state, isLoading: true, fonts: font };
};

const saveChangedFontsSuccess: Handler<IFormsState, SaveChangedFontsSuccessActionType> = state => {
    return { ...state, isLoading: false, error: null };
};

const saveChangedFontsFailure: Handler<IFormsState, SaveChangedFontsFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, error: payload };
};

const transferForm: Handler<IFormsState, TransferFormActionType> = state => {
    return { ...state };
};
const setTransferFormData: Handler<IFormsState, SetTransferFormDataActionType> = (state, { payload }) => {
    return {
        ...state,
        transfer: {
            fields: payload.fields,
            pages: payload.pages,
            logic: payload.logic || [],
            wixFields: payload.wixFields,
            isLoading: true,
        },
    };
};

const transferFormSubmissions: Handler<IFormsState, TransferFormSubmissionsActionType> = state => {
    return { ...state };
};

const setTransferLoading: Handler<IFormsState, SetTransferFormLoadingActionType> = (state, { payload }) => {
    return { ...state, isTransfering: payload.isLoading };
};

export const authHandlers = {
    [FormsActionTypes.INIT_FORM_BUTTONS_STYLES]: initFormButtons,

    [FormsActionTypes.GET_FORMS_REQUEST]: getFormsRequest,
    [FormsActionTypes.GET_FORMS_SUCCESS]: getFormsSuccess,
    [FormsActionTypes.GET_FORMS_FAILURE]: getFormsFailure,

    [FormsActionTypes.GET_FORM_REQUEST]: getFormRequest,
    [FormsActionTypes.GET_FORM_SUCCESS]: getFormSuccess,
    [FormsActionTypes.GET_FORM_FAILURE]: getFormFailure,

    [FormsActionTypes.CREATE_FORM_REQUEST]: createFormRequest,
    [FormsActionTypes.CREATE_FORM_SUCCESS]: createFormSuccess,
    [FormsActionTypes.CREATE_FORM_FAILURE]: createFormFailure,

    [FormsActionTypes.UPDATE_FORM_NAME_REQUEST]: updateFormNameRequest,
    [FormsActionTypes.UPDATE_FORM_NAME_SUCCESS]: updateFormNameSuccess,
    [FormsActionTypes.UPDATE_FORM_NAME_FAILURE]: updateFormNameFailure,

    [FormsActionTypes.UPDATE_FORM_BACKGROUND_REQUEST]: updateFormBackgroundRequest,
    [FormsActionTypes.UPDATE_FORM_BACKGROUND_SUCCESS]: updateFormBackgroundSuccess,
    [FormsActionTypes.UPDATE_FORM_BACKGROUND_FAILURE]: updateFormBackgroundFailure,

    [FormsActionTypes.UPDATE_FORM_PAGE_STYLES_REQUEST]: updateFormPageStylesRequest,
    [FormsActionTypes.UPDATE_FORM_PAGE_STYLES_SUCCESS]: updateFormPageStylesSuccess,
    [FormsActionTypes.UPDATE_FORM_PAGE_STYLES_FAILURE]: updateFormPageStylesFailure,

    [FormsActionTypes.SET_CURRENT_FORM]: setCurrentForm,

    [FormsActionTypes.SET_FORM_STYLES]: setFormStyles,

    [FormsActionTypes.SET_INITIAL_FONTS]: setInitialFonts,
    [FormsActionTypes.GET_USER_FONTS_REQUEST]: getUserFontsRequest,
    [FormsActionTypes.GET_USER_FONTS_SUCCESS]: getUserFontsSuccess,
    [FormsActionTypes.GET_USER_FONTS_FAILURE]: getUserFontsFailure,

    [FormsActionTypes.SAVE_CHANGED_FONTS_REQUEST]: saveChangedFontsRequest,
    [FormsActionTypes.SAVE_CHANGED_FONTS_SUCCESS]: saveChangedFontsSuccess,
    [FormsActionTypes.SAVE_CHANGED_FONTS_FAILURE]: saveChangedFontsFailure,

    [FormsActionTypes.TRANSFER_FORM]: transferForm,
    [FormsActionTypes.SET_TRANSFER_LOADING]: setTransferLoading,
    [FormsActionTypes.SET_TRANSFER_FORM_DATA]: setTransferFormData,
    [FormsActionTypes.TRANSFER_FORM_SUBMISSIONS]: transferFormSubmissions,
};
